import Vue from 'vue'
import { Autocomplete, Collapse, CollapseItem ,Checkbox, Pagination, Dialog, Input, Button, Form, FormItem, RadioGroup, Radio, Select, Upload, Option } from 'element-ui';

Vue.component(Autocomplete.name, Autocomplete);
Vue.component(Button.name, Button);
Vue.component(Checkbox.name, Checkbox);
Vue.component(Collapse.name, Collapse);
Vue.component(CollapseItem.name, CollapseItem);
Vue.component(Dialog.name, Dialog);
Vue.component(Input.name, Input);
Vue.component(Pagination.name, Pagination);
Vue.component(Form.name, Form);
Vue.component(FormItem.name, FormItem);
Vue.component(RadioGroup.name, RadioGroup);
Vue.component(Radio.name, Radio);
Vue.component(Select.name, Select);
Vue.component(Upload.name, Upload);
Vue.component(Option.name, Option);

